import { each } from 'martha'

const cache = {}

export async function get(fetcher, key) {
  if (cache[key]) return cache[key]
  cache[key] = await fetcher()
  return cache[key]
}
